import React, { useState, useEffect } from 'react';
import { Col, Row, Checkbox } from 'antd';
import { useParams } from 'react-router-dom';
import TextField from "@mui/material/TextField";
import {
  SearchOutlined,
} from '@ant-design/icons';
import ConsultarAlimentosIcon from '../assets/iconConsultarAlimentos.png';
import FrutasDerivadosIcon from '../assets/icon_alt_frutas_e_derivados.png';
import VegetaisDerivadosIcon from '../assets/icon_alt_legumes_e_verduras.png';
import LeguminosasDerivadosIcon from '../assets/icon_alt_leguminosas_e_derivados.png';
import GordurasAzeitesIcon from '../assets/icon_alt_oleos_e_gorduras.png';
import SementesOleaginosasIcon from '../assets/icon_alt_cereais_e_oleaginosas.png';
import AcuradosIcon from '../assets/icon_alt_produtos_açucarados.png';
import CarnesDerivadosIcon from '../assets/icon_alt_carnes_e_derivados.png';
import OvosDerivadosIcon from '../assets/icon_alt_ovos_e_derivados.png';
import LeiteDerivadosIcon from '../assets/icon_alt_leite_e_derivados.png';
import BebidasIcon from '../assets/icon_alt_bebidas.png';
import AlimentosEspeciaisIcon from '../assets/icon_alt_alimentos_para_fins_especiais.png';
import AlimentosIndustrializadosIcon from '../assets/icon_alt_alimentos_industrializados.png';
import CereaisIcon from '../assets/icon_alt_cereais_e_derivados.png';
import MiscelaneaIcon from '../assets/icon_miscelanea.png';
import FrutosdoMarIcon from '../assets/icon_alt_pescados_e_frutos_do_mar.png';
import FastFoodIcon from '../assets/icon_alt_fast_food.png';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import {
  ArrowLeftOutlined,
  LoadingOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import './ConsultarAlimentos.scss';
import { useNavigate } from 'react-router-dom'
import { getGrupos, getAlimentos, createRefInDay } from '../service/api';

const iconsRef = {
  'Frutas e Derivados': FrutasDerivadosIcon,
  'Vegetais e Derivados': VegetaisDerivadosIcon,
  'Leguminosas e derivados': LeguminosasDerivadosIcon,
  'Gorduras e azeites': GordurasAzeitesIcon,
  'Sementes e oleaginosas': SementesOleaginosasIcon,
  'Produtos açucarados': AcuradosIcon,
  'Carnes e derivados': CarnesDerivadosIcon,
  'Ovos e derivados': OvosDerivadosIcon,
  'Leite e derivados': LeiteDerivadosIcon,
  'Bebidas': BebidasIcon,
  'Alimentos para fins especiais': AlimentosEspeciaisIcon,
  'Alimentos industrializados': AlimentosIndustrializadosIcon,
  'Cereais e derivados': CereaisIcon,
  'Miscelânea': MiscelaneaIcon,
  'Pescados e frutos do mar': FrutosdoMarIcon,
  'Fast Food': FastFoodIcon,
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const ConsultarAlimentos = () => {
  let navigate = useNavigate();
  const [groupsList, setGroupsList] = useState([])
  const [alimentosList, setAlimentosList] = useState([])
  const [filteredList, setFilteredList] = useState([])
  const [loadingAlimentos, setLoadingAlimentos] = useState(false)
  const [onSearch, setOnSearch] = useState(false)
  const [focusOut, setFocusOut] = useState(true)
  const [checkedItems, setCheckedItems] = useState([])
  const [openFooter, setOpenFooter] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openModalDoubt, setOpenModalDoubt] = useState(false)
  const [inputText, setInputText] = useState("");
  const [lastItemSelected, setLastItemSelected] = useState({})
  const [inputTextModal, setInputTextModal] = useState("");
  const [checkedItemsToSend, setCheckedItemsToSend] = useState([])
  const [medidaCaseira, setMedidaCaseira] = useState("")
  const [quantidademedida, setQuantidademedida] = useState("")
  const [open, setOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  let { day } = useParams();
  let { ref } = useParams();
  let { recipeId } = useParams();

  useEffect(() => {
    const loadGrupos = async () => {
      await getGrupos()
        .then(response => {
          setGroupsList(response)
        })
        .catch(function (error) {
          console.log(error)
        });
    }
    loadGrupos()
    console.log('DIARIO')
  }, []);

  const loadAlimentos = async () => {
    if (!onSearch) {
      console.log("click")
      setFocusOut(false)
      setLoadingAlimentos(true)
      setOnSearch(true)
      await getAlimentos()
        .then(response => {
          setAlimentosList(response)
          setFilteredList(response)
          setLoadingAlimentos(false)
        })
        .catch(function (error) {
          console.log(error)
          setOnSearch(false)
          setLoadingAlimentos(false)
        });
    }
  }

  const onFocusOut = () => {
    console.log("click")
    if (inputText.length == 0) {
      setFocusOut(true)
    }
  }

  const onClickBack = () => {
    console.log("click")
    navigate('/', { replace: true });
  }

  const onClickCategorie = (id, name) => {
    if (day)
      navigate(`/consultar-alimentosDesc/${day}/${ref}/${id}/${name}`, { replace: true });
    else if (recipeId)
      navigate(`/consultar-alimentosDesc/${recipeId}/${id}/${name}`, { replace: true });
    else
      navigate(`/consultar-alimentosDesc/${id}/${name}`, { replace: true });
  }

  const onChange = (checkedValues) => {
    var list = checkedItems
    var listToSend = checkedItemsToSend
    if (list.includes(checkedValues.nome)) {
      const index = list.indexOf(checkedValues.nome);
      list.splice(index, 1);
      listToSend.splice(index, 1);
    } else {
      setLastItemSelected(checkedValues)
      handleOpen()
    }
    setCheckedItems(list)
    setCheckedItemsToSend(listToSend)
    if (list.length > 0)
      setOpenFooter(true)
    else
      setOpenFooter(false)
  };


  const checkHasMedidaCaseira = (item) => {
    if (item) {
      if ((item.medidaCaseira != "" && item.medidaCaseira != "ND") || (item.medidaCaseira2 != "" && item.medidaCaseira2 != "ND") || (item.medidaCaseira3 != "" && item.medidaCaseira3 != "ND")) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  const registrarQuantidade = (item, value, medidaValue) => {
    if (value != "" && medidaValue != "") {
      setErrorMessage("Preencha apenas um dos campos")
      setOpen(true)
    } else if (value != "" || medidaValue != "") {
      var gramasConsumidas
      if (value != "") {
        gramasConsumidas = value
      } else {
        gramasConsumidas = medidaValue
      }
      var list = checkedItems
      var listToSend = checkedItemsToSend
      list.push(item.nome)
      item.consumido = gramasConsumidas
      listToSend.push(item)
      setCheckedItems(list)
      setCheckedItemsToSend(listToSend)
      handleClose()
      if (list.length > 0)
        setOpenFooter(true)
      else
        setOpenFooter(false)
    } else {
      setOpen(true)
      setErrorMessage("Informe a quantidade consumida do alimento")
    }
  }

  const registrarAlimentos = async () => {
    if (recipeId) {
      const recipe = JSON.parse(localStorage.getItem(recipeId))
      var resp = recipe
      console.log(recipe)
      let alimentos = []
      checkedItemsToSend.map(function (item, i) {
        const obj = {
          alimentoid: item.alimentoid,
          quantidade: item.consumido,
          nome: item.nome
        }
        alimentos.push(obj)
      })
      resp.alimentos = resp.alimentos.concat(alimentos)
      localStorage.setItem(recipeId, JSON.stringify(resp))
      navigate(`/calcular-receitas/${recipeId}`, { replace: true });
    } else {
      const date = new Date
      var userId = localStorage.getItem("userId");
      const dayonWeeks = {
        'dom': 0,
        'seg': 1,
        'ter': 2,
        'qua': 3,
        'qui': 4,
        'sex': 5,
        'sab': 6
      }
      let dateSelected = (date.getDate() - date.getDay()) + dayonWeeks[day];
      dateSelected = new Date(date.setDate(dateSelected)).toISOString();
      let alimentos = []
      checkedItemsToSend.map(function (item, i) {
        const obj = {
          alimentoid: item.alimentoid,
          quantidade: item.consumido
        }
        alimentos.push(obj)
      })
      await createRefInDay(alimentos, dateSelected, userId, ref)
        .then(response => {
          if (response) {
            navigate('/diario', { replace: true });
          }
        }).catch(error => {

        })

      //navigate('/diario', { replace: true });
    }
  }

  const handleChange = (event) => {
    setMedidaCaseira(event.target.value)
  };

  let inputHandlerMedidaCaseira = (e) => {
    //convert input text to lower case
    var lowerCase = e.target.value.toLowerCase();
    var consumido
    if (medidaCaseira == lastItemSelected.medidaCaseira) {
      consumido = parseFloat(lowerCase) * parseFloat(lastItemSelected.pesomedidacaseira)
    } else if (medidaCaseira == lastItemSelected.medidaCaseira2) {
      consumido = parseFloat(lowerCase) * parseFloat(lastItemSelected.pesomedidacaseira)
    } else {
      consumido = parseFloat(lowerCase) * parseFloat(lastItemSelected.pesomedidacaseira)
    }
    setQuantidademedida(consumido);
  };

  let inputHandler = (e) => {
    //convert input text to lower case
    var lowerCase = e.target.value.toLowerCase();
    lowerCase = lowerCase.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9 ]/g, '');
    setInputText(lowerCase);
    var filteredImportantData = new Array()
    
    const filteredData = alimentosList.filter((el) => {
      //if no input the return the original
      var normalized = el.nome.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9 ]/g, '')
      var marca = el.marca.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9 ]/g, '')
      var splited = normalized.split(' ')
      if (lowerCase === '') {
        return el;
      }
      //return the item which contains the user input
      else if(splited[0].includes(lowerCase)){
        filteredImportantData.push(el)
      }else if(marca.includes(lowerCase)){
        return marca.includes(lowerCase)
      }else{
        return normalized.includes(lowerCase)
      }

    })
    const result = filteredImportantData.concat(filteredData)
    setFilteredList(result)
  };

  let inputHandlerModal = (e) => {
    //convert input text to lower case
    var lowerCase = e.target.value.toLowerCase();
    setInputTextModal(lowerCase);
  };

  const handleOpen = () => {
    setOpenModal(true)
    setMedidaCaseira("")
    setInputTextModal("")
  };

  const handleClose = () => setOpenModal(false);

  const handleOpenDoubt = () => setOpenModalDoubt(true);
  const handleCloseDoubt = () => setOpenModalDoubt(false);

  const openDesc = (checkedValues) => {
    setLastItemSelected(checkedValues)
    handleOpen()
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div className='consultar'>
      <Row>
        <Col span={24} className='consultar__header'>
          <ArrowLeftOutlined className='consultar__icons' onClick={onClickBack} />
          <img src={ConsultarAlimentosIcon} alt='' className='consultar__logo' />
          <p className='consultar__title'>Consultar Alimentos</p>
        </Col>
      </Row>
      <div className='consultar__search'>
        <TextField
          id="input-with-sx"
          fullWidth
          label="Buscar Alimento"
          onChange={inputHandler}
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlined />
              </InputAdornment>
            ),
          }}
          onFocus={() => loadAlimentos()}
          onBlur={() => onFocusOut()}
        />
      </div>
      {
        loadingAlimentos ?
          <LoadingOutlined />
          :
          alimentosList.length == 0 || focusOut ?
            <div className='consultar__grid-container'>
              {
                groupsList.map(function (item, i) {
                  return (
                    <div key={i + "a"} onClick={() => onClickCategorie(item.grupoid, item.nome)}>
                      <img key={i + "b"} src={iconsRef[item.nome]} alt='' className='consultar__logo' />
                      <div key={i + "c"} className="consultar__grid-itemName">{item.nome}</div>
                    </div>
                  )
                })
              }
            </div>
            :
            <div>
              <p className='consultar__teorProteina'>Teor de Proteína</p>
              <div className='consultar__tabela'>
                <div style={{ height: 15, width: 15, backgroundColor: 'red', marginTop: 13, marginRight: 5, borderRadius: 10 }} />
                <p style={{ marginRight: 15 }}>Alto</p>
                <div style={{ height: 15, width: 15, backgroundColor: 'orange', marginTop: 13, marginRight: 5, borderRadius: 10 }} />
                <p style={{ marginRight: 15 }}>Médio</p>
                <div style={{ height: 15, width: 15, backgroundColor: 'green', marginTop: 13, marginRight: 5, borderRadius: 10 }} />
                <p style={{ marginRight: 15 }}>Baixo</p>
                <div style={{ marginTop: -17, marginLeft: -30, color: '#0000EE' }}>
                  <QuestionCircleOutlined onClick={handleOpenDoubt} />
                </div>
              </div>
              {
                filteredList.map(function (item, i) {
                  return (
                    <Checkbox.Group style={{ width: '100%' }}>
                      <div key={i} className="consultar__grid-item" onClick={() => (!day || recipeId) && openDesc(item)}>
                        {
                          (day || recipeId) &&
                          <Checkbox value={item.nome} style={{ paddingLeft: 10, paddingRight: 5 }} onChange={() => onChange(item)} />
                        }
                        <div style={{ width: 250, marginLeft: 5, color: '#555555' }}>
                          {
                            item.nome.length > 40 ?
                              item.nome.substr(0, 40) + " ..."
                              :
                              item.nome
                          }
                        </div>
                        {
                          item.name == "Gorduras e azeites" || parseFloat(item.proteina.replace(',', '.')) <= 0.5 ?
                            <div style={{ height: 15, width: 15, backgroundColor: 'green', marginTop: 3, marginLeft: 5, borderRadius: 10 }} />
                            : parseFloat(item.proteina.replace(',', '.')) > 0.5 && parseFloat(item.proteina.replace(',', '.')) < 1.2 ?
                              <div style={{ height: 15, width: 15, backgroundColor: 'orange', marginTop: 3, marginLeft: 5, borderRadius: 10 }} />
                              : parseFloat(item.proteina.replace(',', '.')) > 1.2 ?
                                <div style={{ height: 15, width: 15, backgroundColor: 'red', marginTop: 3, marginLeft: 5, borderRadius: 10 }} />
                                :
                                ""
                        }
                      </div>
                    </Checkbox.Group>
                  )
                })
              }
            </div>

      }
      {
        openFooter && (day || recipeId) &&
        <div class="consultar__footer" onClick={registrarAlimentos}>
          <p>Inserir Alimentos</p>
        </div>
      }
      <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
      </Snackbar>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="consultar__modalNutrientes">
            <div className="consultar__modal" style={{ fontSize: 13 }}>
              Porção de 100g
            </div>
            <div className="consultar__modal">
              <b>Alimento:</b> {lastItemSelected.nome}
            </div>
            {lastItemSelected.proteina != "ND" &&
              <div className="consultar__modal">
                <b>Proteína:</b> {lastItemSelected.proteina}g
              </div>
            }
            {lastItemSelected.carboidrato != "ND" &&
              <div className="consultar__modal">
                <b>Carboidrato:</b> {lastItemSelected.carboidrato}g
              </div>
            }
            {lastItemSelected.energia != "ND" &&
              <div className="consultar__modal">
                <b>Valor Enegético:</b> {lastItemSelected.energia}kcal
              </div>
            }
            {lastItemSelected.lipidios != "ND" &&
              <div className="consultar__modal">
                <b>Lipídios:</b> {lastItemSelected.lipidios}mg
              </div>
            }
            {lastItemSelected.calcio != "ND" &&
              <div className="consultar__modal">
                <b>Cálcio:</b> {lastItemSelected.calcio}mg
              </div>
            }
            {lastItemSelected.cistina != "ND" &&
              <div className="consultar__modal">
                <b>Cistina:</b> {lastItemSelected.cistina}mg
              </div>
            }
            {lastItemSelected.fenilanina != "ND" &&
              <div className="consultar__modal">
                <b>Fenilanina:</b> {lastItemSelected.fenilanina}mg
              </div>
            }
            {lastItemSelected.fibras != "ND" &&
              <div className="consultar__modal">
                <b>Fibras:</b> {lastItemSelected.fibras}g
              </div>
            }
            {lastItemSelected.isoleucina != "ND" &&
              <div className="consultar__modal">
                <b>Isoleucina:</b> {lastItemSelected.isoleucina}mg
              </div>
            }
            {lastItemSelected.leucina != "ND" &&
              <div className="consultar__modal">
                <b>Leucina:</b> {lastItemSelected.leucina}mg
              </div>
            }
            {lastItemSelected.lisina != "ND" &&
              <div className="consultar__modal">
                <b>Lisina:</b> {lastItemSelected.lisina}mg
              </div>
            }
            {lastItemSelected.metionina != "ND" &&
              <div className="consultar__modal">
                <b>Metionina:</b> {lastItemSelected.metionina}mg
              </div>
            }
            {lastItemSelected.tirosina != "ND" &&
              <div className="consultar__modal">
                <b>Tirosina:</b> {lastItemSelected.tirosina}mg
              </div>
            }
            {lastItemSelected.treonina != "ND" &&
              <div className="consultar__modal">
                <b>Treonina:</b> {lastItemSelected.treonina}mg
              </div>
            }
            {lastItemSelected.valina != "ND" &&
              <div className="consultar__modal">
                <b>Valina:</b> {lastItemSelected.valina}mg
              </div>
            }
            {lastItemSelected.vitb12 != "ND" &&
              <div className="consultar__modal">
                <b>Vitamina b12:</b> {lastItemSelected.vitb12}mcg
              </div>
            }
            {lastItemSelected.marca != "ND" &&
              <div className="consultar__modal">
                <b>Marca:</b> {lastItemSelected.marca}
              </div>
            }
          </div>
          {
            (day || recipeId) &&
            <div className='consultar__inputModal' style={{ marginTop: 20 }}>
              <div style={{ fontSize: 10, color: 'red' }}>preencha um dos campos*</div>
              <TextField
                id="input-with-sx"
                fullWidth
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Quantidade Consumida (g)"
                onChange={inputHandlerModal}
                variant="standard"
              />
              {/* <div style={{ fontSize: 10, color: 'red' }}>campo obrigatório*</div> */}
              {
                checkHasMedidaCaseira(lastItemSelected) &&
                <div style={{ marginTop: 10 }}>
                  <FormControl variant="standard" sx={{ m: 0, minWidth: 140 }}>
                    <InputLabel id="demo-simple-select-standard-label">Medida Caseira</InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={medidaCaseira}
                      onChange={handleChange}
                      label="Medida Caseira"
                    >
                      <MenuItem value={lastItemSelected.medidacaseira}>
                        <em>{lastItemSelected.medidacaseira}</em>
                      </MenuItem>
                      <MenuItem value={lastItemSelected.medidacaseira2}>
                        <em>{lastItemSelected.medidacaseira2}</em>
                      </MenuItem>
                      <MenuItem value={lastItemSelected.medidacaseira3}>
                        <em>{lastItemSelected.medidacaseira3}</em>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              }

              {
                medidaCaseira != "" &&
                <TextField
                  id="input-with-sx"
                  fullWidth
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ marginTop: 10 }}
                  label={"Quantas medidas caseiras"}
                  onChange={inputHandlerMedidaCaseira}
                  variant="standard"
                />
              }

              <div className='consultar__cardSearch' onClick={() => registrarQuantidade(lastItemSelected, inputTextModal, quantidademedida)}>
                Concluir
              </div>
            </div>
          }
        </Box>
      </Modal>
      <Modal
        open={openModalDoubt}
        onClose={handleCloseDoubt}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </Box>
      </Modal>
    </div>
  )
}

export default ConsultarAlimentos
